module.exports = new __parcel__URL__("logo_wla.5c05c7c3.png").toString();